import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil, take } from 'rxjs/operators';
import { AddAlertPoolDataService } from 'services/add-alert-pool-data.service';
import { AllAlertFiltersService } from 'services/all-alert-filters.service';
import { DrawerStatusService } from 'services/status/drawer-status.service';
import { UnsavedChangesDialogService } from 'services/unsaved-changes-dialog.service';
import { DisplayableServerError } from 'types/DisplayableServerError';
import { RequestStatus } from 'types/RequestStatus';
import { getDisplayableServerError } from 'utils/get-displayable-server-error';
import { VueDrawerConfig, VueDrawerComponent } from 'vue/components/vue-drawer/vue-drawer.component';
import { PoolStep, AddPoolState } from '../add-pool-drawer/add-pool-state/add-pool-state.service';
import { DEFAULTSTATUSVALUE } from '../copy-pool-consumption-drawer/copy-pool-consumption-drawer.component';
import { UnderutilizationService } from 'services/api/underutilization.service';
import { AlertEditPcToastComponent } from 'components/common/alerts/alert-edit-pc-toast/alert-edit-pc-toast.component';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-underutilization-edit-drawer',
  standalone: false,
  templateUrl: './underutilization-edit-drawer.component.html',
  styleUrl: './underutilization-edit-drawer.component.scss'
})
export class UnderutilizationEditDrawerComponent {
@ViewChild(AlertEditPcToastComponent) public editPoolToast!: AlertEditPcToastComponent;
selectedFilters: any[] = []
  toastMessage: any;
  selectedfilterboolean: boolean = false;
  @Output() public success = new EventEmitter<any>();
  @Input() public underutilizationedit:any;
  @Input() copyAlertFormData: any;
  addPoolForm!: FormGroup;
  getDataForCreateAlert: any = null;
  disabledAtresponsegetting: any = false;
  public step: PoolStep = 'form';
  public drawerConfig: VueDrawerConfig = {
    disableClose: true,
  };
    payload:any
  private error?: DisplayableServerError | null;
  public status: RequestStatus = 'initial';
  @ViewChild('drawer') public drawer!: VueDrawerComponent;
  errorMessage: any;
  getRecordId:any;
  childupdatedValuestatus: any = false;
  private destroyed$ = new Subject();
  getFlagfromobserver: any = false;
  constructor(private addPoolState: AddAlertPoolDataService, private addPoolStates: AddPoolState,
    private drawerStatusService: DrawerStatusService,
    private unsavedChangesDialogService: UnsavedChangesDialogService,
    private addAlertConsumptionCreate: AddAlertPoolDataService,
     private underutilizationservice:UnderutilizationService,
    private allPoolsFilterService: AllAlertFiltersService,
    private router:ActivatedRoute
  ) { }

  ngOnInit(): void {
     this.router.url.subscribe((ele:any)=>{
      this.getRecordId=ele[3].path
    });
    this.addAlertConsumptionCreate.gettableFilterUpdate$.subscribe((ele: any) => {
      this.getFlagfromobserver = ele;
    });
    this.drawerStatusService.status$
      .pipe(takeUntil(this.destroyed$))
      .subscribe((status) => {
        this.status = status;
      });
    this.addAlertConsumptionCreate.errorobjects$.subscribe((ele: any) => {
      if (ele) {
        this.status = 'error';
        this.error = { message: ` Time: ${ele.runTime}(UTC) - Day: ${ele.Element}`, title: ` RunFrequency Duplicate are not allowed` };
        this.drawerStatusService.error();
      }
    })
    this.allPoolsFilterService.selectedFilters$
      .pipe(takeUntil(this.destroyed$))
      .subscribe((selectedFilters) => {
        this.selectedFilters = [...selectedFilters];
        if (!this.checkstatusValue(this.selectedFilters)) {
          this.selectedfilterboolean = true;


        }
      });
  }

  public ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  public get displayableServerError(): DisplayableServerError | null | undefined {
    return this.addPoolStates.displayableServerError || this.error;
  }

  public closeDrawerbtn(): void {
    

    if (this.childupdatedValuestatus) {
      this.unsavedChangesDialogService.open().pipe(take(1)).subscribe((choseToLeave) => {
        if (choseToLeave) {
          this.getDataForCreateAlert = null;
          this.closeDrawer();
         
        }
      });
    }
    else {
      this.closeDrawer();
      
    }
  }

    getvalidform(event:any){
      
    if(event != null ){
      this.createpayload(event)
    }
    
    
   this.getDataForCreateAlert= event;
  }

  public closeDrawer(): void {
    this.drawer.close();
    this.reset();
  }

  public reset(): void {
    this.addPoolState.resetState();
    this.drawerStatusService.reset();
  }

  getdatafromchild(event: any) {
    this.getDataForCreateAlert = event;
  }

  // SavePool() {
  //   this.drawerStatusService.loading();
  //   this.errorMessage = null;
  //   this.disabledAtresponsegetting = true;
  //   let checkValidationerror = this.getfilterValue(this.getDataForCreateAlert);
  //   if (checkValidationerror.length == 0) {
  //     this.addAlertConsumptionCreate.createAlertConsumption(this.getDataForCreateAlert).subscribe((response) => {
  //       if (response.id) {
  //         this.success.emit(response);
  //         this.closeDrawer();
  //         this.error = null;
  //         this.addAlertConsumptionCreate.getupdatedlist(null)
  //         this.drawerStatusService.success();
  //         if (this.getFlagfromobserver) {
  //           this.allPoolsFilterService.addClientsToFilter([]);
  //           this.allPoolsFilterService.updateMoreFilters();
            
  //         }
  //       }
  //     }, (error: unknown) => {
  //       this.disabledAtresponsegetting = false;
  //       this.error = getDisplayableServerError(error);
  //       this.drawerStatusService.error();
  //     });
  //   }
  // }


   SavePool() {
    
    
    this.drawerStatusService.loading();
    this.errorMessage = null;
    this.disabledAtresponsegetting = true;
      this.underutilizationservice.createEditPool(this.payload,this.getRecordId).pipe(take(1)).subscribe((response:any)  => {
     
      
          this.closeDrawer();
          this.error = null;
           this.getupdateddata()
          
          this.drawerStatusService.success();
        
        
      }, (error: unknown) => {
       
        this.error = getDisplayableServerError(error);
        this.drawerStatusService.error();
      });
    
  }
  

  getStatusofchild(event: any) {
    
    this.drawerStatusService.reset();
    this.childupdatedValuestatus = event;
  }

  cancelDrawer() {
    if (this.childupdatedValuestatus) {
      this.unsavedChangesDialogService.open().pipe(take(1)).subscribe((choseToLeave) => {
        if (choseToLeave) {
          this.getDataForCreateAlert = null;
          this.closeDrawer();
        }
      });
    }
    else {
      this.closeDrawer();
    }
  }


  getrunfrequencyupdated(value: any) {
    const idMap = new Map();
    const duplicates: any = [];
    for (const obj of value) {
      const { runTime, runDaysOfWeek, isCritical, runPriority } = obj;
      if (idMap.has(runTime)) {
        const existingArray = idMap.get(runTime);
        if (existingArray.isCritical === isCritical && existingArray.runPriority === runPriority) {
          const currentDuplicates = [];
          for (const element of runDaysOfWeek) {
            if (existingArray.runDaysOfWeek.indexOf(element) !== -1) {
              currentDuplicates.push(element);
              this.addAlertConsumptionCreate.getupdatedlist({ 'Element': element, 'runTime': runTime });
            }
          }
          if (currentDuplicates.length > 0) {
            duplicates.push({ runTime, isCritical, runPriority, duplicates });
          }
          existingArray.runDaysOfWeek = [...new Set([...existingArray.runDaysOfWeek, ...runDaysOfWeek])];
        }

      } else {
        idMap.set(runTime, { runDaysOfWeek, isCritical, runPriority });
      }
    }
    return duplicates;
  }

  getfilterValue(filter: any) {
    let value: any = [];
    filter.run_Frequency.FormGroup.Time.forEach((ele: any) => {
      let arraylist: any = [];
      ele.weekDays.forEach((data: any) => {
        if (data.checked == true)
          arraylist.push(data.value);
      })
      value.push(
        {
          "runTime": ele.Time,
          "runPriority": ele.Priority,
          "isCritical": ele.Critical,
          "daysFlag": arraylist.length == 7 ? "daily" : "weekly",
          "runDaysOfWeek": arraylist
        })
    });
    const result = this.getrunfrequencyupdated(value);
    return result;
  }

  checkstatusValue(arr: any) {
    return arr[0]?.content.includes('Open') && arr[1]?.content.includes('Scheduled')
  }

 createpayload(data:any){
  
 if(data?.Time.before){
    if(data?.Time.before.startTime[0].startTime == null && data?.Time.before.startTime[0].endTime == null){
       data.Time.before.startTime = []
    }
     
   }
   else{
     
   }
   let payload = {
  "alertName": data.alertname,
  "type": "Under Utilization",
  "daysToCheck": data?.Time?.after?.next  == undefined ? `${data?.Time?.daystocheck}`:`${data?.Time?.after?.next}-${data?.Time?.after?.day}`,
  "queueId": data?.Queue?.id,
  "isPerDay":  data?.Time?.before?.optionControl == undefined ? data?.Time?.isPerDay : data?.Time?.before?.optionControl == 0 ? true : false ,
  "isHourly": data?.Time?.before?.optionControl == undefined ? data?.Time?.isHourly: data?.Time?.before?.optionControl == 1 ? true : false,
  "UU_Schedule": {
    "perDay": data?.Time?.before?.startTime == undefined ? data?.Time.alertschdule.perDay : data?.Time?.before?.startTime,
    "isAllDay": data?.Time.before?.allday == undefined ? data?.Time.alertschdule.isAllDay : data?.Time.before?.allday,
    "intervalVal": data?.Time.before?.Consecutive == undefined ? data?.Time.alertschdule.intervalVal : data?.Time.before?.Consecutive,
    "hours": data?.Time?.before?.hours == undefined ? data?.Time.alertschdule.hours : data?.Time?.before?.hours 
  },
  "threshold": {
   
      
        "percentage": data?.Time?.before?.percentage == undefined ? data?.Time?.percentage : data?.Time?.before?.percentage,
        "email": data.Email
      
    
  },
  "runFrequency": {
  
        "runTime":data.executive

  }
}

this.payload=payload;
  }

 getupdateddata(){
       this.toastMessage=this.payload.alertName;
      this.editPoolToast.openToast(this.toastMessage);
      this.addAlertConsumptionCreate.triggerRefresh();
  
   }
}
